//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import fileUploader from '../../../views/common-components/file-uploader';
import {formatDate} from '../../../../src/lib/date';
import arrayToTree from 'array-to-tree';

export default {
    name: 'activity-baseinfo',
    components: {
        fileUploader
    },
    props: {
        activityInfo: {
            type: Object,
            required: true
        }
    },
    filters: {
        formatDate(time, type) {
            var date = new Date(time);
            if (type == 1) {
                return formatDate(date, 'yyyy-MM-dd');
            }
            return formatDate(date, 'yyyy-MM-dd hh:mm');
        }
    },
    data() {
        return {
            activity: {},
            showActivityEditModal: false,
            rules: {
                activityName: {required: true, message: '请输入活动名称', trigger: 'blur'},
                activityType: {required: true, type: 'number', message: '请选择活动类型', trigger: 'change'},
                introduction: {required: true, message: '请输入活动简介', trigger: 'blur'},
                address: {required: true, message: '请输入活动地点', trigger: 'blur'},
                householdNum: {required: true, type: 'number', message: '请输入每户限制人数', trigger: 'blur'}
                // startDateTime: [{ required: true, type: 'datetime', message: '请选择活动开始日期', trigger: 'change' }],
                // endDateTime: [{ required: true, type: 'datetime', message: '请选择活动结束日期', trigger: 'change' }]
            },
            saving: false,
            activityInfoN: {
                file: {associateType: 'ActivityLogo', addAttrIds: []}
            },
            indeterminate: true,
            checkAll: false,
            checkAllGroup: [],
            showTreeModal: false,
            projectTree: [],
            cityRanges: [],
            isEditRange: false

        };
    },
    methods: {
        cancel() {
            this.saving = false;
            this.showActivityEditModal = false;
        },
        onSave() {
            var vm = this;
            if (!vm.activityInfoN.startDateTime) {
                abp.message.error('请输入活动开始时间');
                return;
            }
            if (!vm.activityInfoN.endDateTime) {
                abp.message.error('请输入活动结束时间');
                return;
            }
            if (!vm.activityInfoN.isLimit) {
                this.activityInfoN.totalNum = '';
            }

            vm.activityInfoN.memberLevel = this.checkAllGroup.toString();

            vm.activityInfoN.cityRanges = vm.cityRanges;
            vm.activityInfoN.oldCityRanges = [];
            if (this.activity.cityRanges.length > 0 && vm.cityRanges.length != 0) {
                vm.activityInfoN.oldCityRanges = this.activity.cityRanges;
            }
            // if (!this.isEditRange) {
            //     vm.activityInfoN.cityRanges = [];
            // }
            vm.activityInfoN.isEditRange = this.isEditRange;

            this.$refs.activityForm.validate(async (val) => {
                if (val) {
                    vm.saving = true;
                    vm.$store.dispatch({
                        type: 'activity/saveActivity',
                        data: vm.activityInfoN
                    }).then(() => {
                        vm.$Notice.success({
                            duration: 3,
                            title: '保存成功'
                        });
                        vm.showActivityEditModal = false;
                        // vm.getActivity();
                        vm.$emit('getActivity');
                    }).finally(() => {
                        vm.saving = false;
                    });
                }
            });
        },

        editActivity() {
            this.activityInfoN = JSON.parse(JSON.stringify(this.activity));
            this.cityRanges = this.activityInfoN.cityRanges;
            this.isEditRange = false;
            this.activityInfoN.file = {associateType: 'ActivityLogo'};
            // this.activityInfoN.isLimit = true;
            this.saving = false;
            this.showActivityEditModal = true;
        },
        handleCheckAll() {
            if (this.indeterminate) {
                this.checkAll = false;
            } else {
                this.checkAll = !this.checkAll;
            }
            this.indeterminate = false;

            if (this.checkAll) {
                this.checkAllGroup = ['0', '1', '2', '3', '4'];
                // this.checkAllGroup = ['2', '3', '4'];
            } else {
                this.checkAllGroup = [];
            }
        },
        checkAllGroupChange(data) {
            if (data.length === 5) {
                this.indeterminate = false;
                this.checkAll = true;
            } else if (data.length > 0) {
                this.indeterminate = true;
                this.checkAll = false;
            } else {
                this.indeterminate = false;
                this.checkAll = false;
            }
        },
        getProjectStagesTree() {
            abp.ajax.get('/api/services/app/Project/GetProjectStagesTree').then(res => {
                // this.getActivity();

                this.projectTree = [];
                this.projectTree = res.data.result.items;
                this.projectTree.forEach((item, index) => {
                    item.title = item.name;
                    item.children = item.projects;
                    item.type = 'city';
                    item.children.forEach(item => {
                        item.children = item.stages;
                        item.parentId = item.cityId;
                        item.type = 'project';
                        item.children.forEach(i => {
                            i.parentId = i.projectId;
                            i.type = 'fenqi';
                        });
                    });
                });

                this.projectTree = arrayToTree(this.projectTree, {
                    parentProperty: 'parentId',
                    customID: 'id'
                });
            }).finally(() => {
                // this.saving = false;
            });
        },
        onSelectTree() {
            var list = this.$refs.treeRef.getCheckedAndIndeterminateNodes();

            this.cityRanges = [];
            var select = list.filter(x => x.type === 'city');
            select.forEach(city => {
                this.cityRanges.push({
                    id: 0,
                    businessId: 0,
                    cityId: city.id,
                    businessType: 'Activity',
                    cityName: city.title,
                    isAllCity: city.checked
                });
            });
            for (var i = 0; i < this.cityRanges.length; i++) {
                this.cityRanges[i].projectRanges = [];
                var s1 = list.filter(x => x.cityId === this.cityRanges[i].cityId);
                var sss = [];
                s1.forEach(project => {
                    sss.push({
                        id: 0,
                        cityRangeId: 0,
                        projectId: project.id,
                        projectName: project.title,
                        cityId: project.cityId,
                        isAllProject: project.checked
                        // projectId: item.projectId
                    });
                });

                this.cityRanges[i].projectRanges = sss;

                for (var j = 0; j < this.cityRanges[i].projectRanges.length; j++) {
                    this.cityRanges[i].projectRanges[j].stagesRanges = [];
                    var s2 = list.filter(x => x.projectId === this.cityRanges[i].projectRanges[j].projectId);

                    var ssss = [];
                    s2.forEach(s => {
                        ssss.push({
                            id: 0,
                            projectRangeId: 0,
                            name: s.title,
                            projectId: s.projectId
                        });
                    });
                    this.cityRanges[i].projectRanges[j].stagesRanges = ssss;
                }

            }
            this.showTreeModal = false;
            this.isEditRange = true;
        }

    },
    created() {
        this.activity = this.activityInfo;
        if (this.activity.memberLevel != null && this.activity.memberLevel != '' && this.activity.memberLevel != undefined) {
            this.checkAllGroup = this.activity.memberLevel.split(',');
        }
        this.getProjectStagesTree();

    },
    watch: {
        activityInfo() {
            this.activity = this.activityInfo;

            this.isEditRange = false;
            if (this.activity.memberLevel != null && this.activity.memberLevel != '' && this.activity.memberLevel != undefined) {
                this.checkAllGroup = this.activity.memberLevel.split(',');
            }
        }
    }
};
